import { render, staticRenderFns } from "./iq-card-dashboard.vue?vue&type=template&id=acf6b1c2&"
import script from "./iq-card-dashboard.vue?vue&type=script&lang=js&"
export * from "./iq-card-dashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports